var $ = require('jquery');
var _ = require('underscore');
var TorsoView = require('backbone-torso/modules/View');
var UseModalBehavior = require('./../widget/modal/UseModalBehavior');
var ModalDialogWidget = require('./../widget/modal/ModalDialogWidget');
var TimeoutCountdownView = require('./TimeoutCountdownView');

require('./../../target/node_modules/vecna-javascript/jquery-ui.js');
require('./../../target/node_modules/vecna-javascript/jquery.idletimeout.vecna-combined.js');

/**
  * View that setups the vecnaIdleTimeout widget.
  *
  * @class TimeoutWidgetView
  * @constructor
  * @extends Torso.View
  * @param options {Object}
  *   @param [options.logoutUrl] {String} the logout URL to redirect to
  */
module.exports = TorsoView.extend({

  behaviors: {
    useModalBehavior: {
      behavior: UseModalBehavior
    }
  },

  /**
    * @method initialize
    * @param options {Object}
    *        options.idleAfter {Number} how long (in seconds) the user should be inactive for the timeout warning dialog to appear
    *        options.warningLength {Number} amount of time in seconds to display the warning dialog before logging out
    *        options.pollingInterval {Number} how often in seconds to issue an AJAX request to the keep-alive URL to keep the session open (when there is activity that doesn't result in explicit refreshes)
    *        options.logoutUrl {String} the logout URL to redirect to
    *        options.keepAliveUrl {String} the keepAliveUrl URL to poll
    *        options.keepAliveMethod {String} HTTP request method to use when polling keepAliveUrl
    * @override
    */
  initialize: function(options) {
    _.bindAll(this, 'stopAndClose', 'reset', '_openTimeoutModal', '_closeTimeoutModal', '_resume', '_logout');

    this._setIdleTimeoutParams(options);

    /**
     * @property _timeoutWidget {Object} the dom element that the jquery widget is attached to
     * @private
     */
    this._timeoutWidget = $('body');
    this._setupTimeoutWidget();
  },

  /**
    * Stop all timers and close the modal
    *
    * @method stopAndClose
    */
  stopAndClose: function() {
     this._timeoutWidget.vecnaIdleTimeout('stop');
     this._closeTimeoutModal();
  },

  /**
   * @method _setOptions
   * @param options {Object}
   *        options.idleAfter {Number} how long (in seconds) the user should be inactive for the timeout warning dialog to appear
   *        options.warningLength {Number} amount of time in seconds to display the warning dialog before logging out
   *        options.pollingInterval {Number} how often in seconds to issue an AJAX request to the keep-alive URL to keep the session open (when there is activity that doesn't result in explicit refreshes)
   *        options.logoutUrl {String} the logout URL to redirect to
   *        options.keepAliveUrl {String} the keepAliveUrl URL to poll
   *        options.keepAliveMethod {String} HTTP request method to use when polling keepAliveUrl
   *
   * @private
   */
  _setIdleTimeoutParams: function(options) {
    this._idleAfter = options.idleAfter ? options.idleAfter : 1200;
    this._warningLength = options.warningLength ? options.warningLength : 60;
    this._pollingInterval = options.pollingInterval ? options.pollingInterval : 1320;
    this._logoutUrl = options.logoutUrl;
    this._keepAliveUrl = options.keepAliveUrl;
    this._keepAliveMethod = options.keepAliveMethod ? options.keepAliveMethod : 'GET';
  },

  /**
   * Resets the vecna idle timeout with new parameters
   * @method resetWithParams
   * @param options {Object}
   *        options.idleAfter {Number} how long (in seconds) the user should be inactive for the timeout warning dialog to appear
   *        options.warningLength {Number} amount of time in seconds to display the warning dialog before logging out
   *        options.pollingInterval {Number} how often in seconds to issue an AJAX request to the keep-alive URL to keep the session open (when there is activity that doesn't result in explicit refreshes)
   *        options.logoutUrl {String} the logout URL to redirect to
   *        options.keepAliveUrl {String} the keepAliveUrl URL to poll
   *        options.keepAliveMethod {String} HTTP request method to use when polling keepAliveUrl
   */
  resetWithParams: function(options) {
    this._setIdleTimeoutParams(options);
    this._setupTimeoutWidget();
    this.reset();
  },

  /**
    * Reset all timers
    *
    * @method reset
    */
  reset: function() {
     this._timeoutWidget.vecnaIdleTimeout('reset');
  },

  /**
    * Sets up the vecna idle timeout widget and setups up callbacks to modal controls and logout
    * @method _setupTimeoutWidget
    * @private
    */
  _setupTimeoutWidget: function() {
    this._timeoutWidget.vecnaIdleTimeout({
      countdown: '#idle-timeout-countdown',
      idleAfter: this._idleAfter,
      warningLength: this._warningLength,
      timeoutAction: this._logout,
      onIdleCallback: this._openTimeoutModal,
      onResumeCallback: this._closeTimeoutModal,
      keepAliveUrl: this._keepAliveUrl,
      keepAliveMethod: this._keepAliveMethod,
      pollingInterval: this._pollingInterval
    });
  },

  /**
    * Open the modal.
    * @method _openTimeoutModal
    * @private
    */
  _openTimeoutModal: function() {
    //using the basic confirmation modal as a wrapper.
    this._modal = new ModalDialogWidget({
      dataViewName: 'confirm timeout',
      className: 'brec-dialog brec-dialog--regular',
      headerKey: 'timeout.modal.header',
      hideClose: true,
      trackedView: new TimeoutCountdownView(),
      yesKey: 'timeout.modal.keepWorking',
      noKey: 'timeout.modal.logout'
    });

    var thisView = this;
    // confirmation is treated as 'keep working' while cancellation is treated as 'log out'
    this.showModal(this._modal, function() {
      thisView._modal = null;
      thisView._resume();
    }, function() {
      thisView._modal = null;
      thisView._logout();
    });
  },

  /**
    * Close the modal
    * @method _closeTimeoutModal
    * @private
    */
  _closeTimeoutModal: function() {
    if (this._modal) {
      // will trigger the modal's callback, above
      // as if they clicked the 'keep working' button
      this._modal.confirm();
    }
  },

  /**
    * Trigger the resume() function on the vecna idle timeout widget
    * @method _resume
    * @private
    */
  _resume: function() {
    this._timeoutWidget.vecnaIdleTimeout('resume');
  },

  /**
    * Redirect to the logout url
    * @method _logout
    * @private
    */
  _logout: function() {
    window.location.assign(this._logoutUrl);
  }
});
